import { type FC } from 'react';
import {
  CurrencyCircleDollar
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCurrencyCircleDollarProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCurrencyCircleDollar: FC<UiIconCurrencyCircleDollarProps> = (props) => {
  return (
    <UiIcon
      IconComponent={CurrencyCircleDollar}
      {...props}
    />
  );
};
